// src/components/Footer.jsx
import React from 'react';
import { Home, Library, Gem, Mail } from 'lucide-react';

const Footer = ({ activePage, setActivePage }) => {
  const navItems = [
    { id: 'home', icon: <Home size={20} />, label: 'Home' },
    { id: 'albums', icon: <Library size={20} />, label: 'Albums' },
    { id: 'about', icon: <Gem size={20} />, label: 'About' },
    { id: 'contact', icon: <Mail size={20} />, label: 'Contact' },
  ];

  return (
    <footer className="fixed bottom-0 left-0 right-0 flex justify-center w-full text-white py-3 z-20"
      style={{
        backgroundColor: 'rgba(10, 10, 10, 0.9)',
        borderTop: '1px solid rgba(255, 255, 255, 0.06)',
        backdropFilter: 'blur(12px)',
      }}
    >
      <nav className="max-w-xl w-full flex justify-around">
        {navItems.map(item => (
          <button
            key={item.id}
            onClick={() => setActivePage(item.id)}
            className={`flex flex-col items-center font-handwritten text-sm transition-all duration-200 ${
              activePage === item.id
                ? 'text-sky-300 scale-105'
                : 'text-white text-opacity-30 hover:text-opacity-60'
            }`}
          >
            {item.icon}
            <span className="mt-1">{item.label}</span>
          </button>
        ))}
      </nav>
    </footer>
  );
};

export default Footer;
